import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import Rating from 'react-rating';
import classnames from 'classnames';

import formControl from '../formControl';
import styles from './styles.css';

function Stars({ input: { value, onChange }, clearable, className }) {
  const reset = useCallback(() => onChange(undefined));
  return (
    <span className={classnames(styles.rating, className)}>
      <Rating
        emptySymbol="fa fa-star-o fa-2x"
        fullSymbol="fa fa-star fa-2x"
        initialRating={value}
        onClick={onChange}
        readonly={!onChange}
      />
      {onChange && clearable && (
        <span
          role="button"
          tabIndex="0"
          onClick={reset}
          className={styles.clearBtn}
        >
          ×
        </span>
      )}
    </span>
  );
}

Stars.defaultProps = {
  input: {
    value: 0,
    onChange: undefined,
  },
  clearable: true,
  className: undefined,
};

Stars.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
  }),
  clearable: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default compose(
  formControl,
)(Stars);
